import React, { useContext, useEffect, useState } from "react";
import Select, { StylesConfig, components } from 'react-select';
import SideMenuCommonFilter from "../../../contextApi/SideMenuCommonFilter";
import SideMenuCommonFilterLib from "../../../contextApi/SideMenuCommonFilterLib";

const FilterZoneWidget = (props) => {

    const {
        ele,
        filterBtnsSelected,
        openFilterLayout,
        setFilterBtnsSelected,
    } = props;

    const accessor = ele.accessor;
    const selected = openFilterLayout === ele.name;
    const [sideMenuCommonFilterContext, setSideMenuCommonFilterContext] = useContext(SideMenuCommonFilter);
    const [sideMenuCommonFilterLibContext, setSideMenuCommonFilterLibContext] = useContext(SideMenuCommonFilterLib);
    const [loading, setLoading] = useState(false);
    const [isZoneMenuOpen, setIsZoneMenuOpen] = useState(false);
    const [allZones, setAllZones] = useState([]);
    const [selectedZone, setSelectedZone] = useState([...filterBtnsSelected.singleZone]);

    useEffect(() => {
        convertZones();
    }, [sideMenuCommonFilterLibContext]);

    const convertZones = () => {
        let zones = [];
        let allZipcodes = [];
        if (sideMenuCommonFilterLibContext.comp_zipcode) {
            allZipcodes = allZipcodes.concat(sideMenuCommonFilterLibContext.comp_zipcode);
        }
        if (sideMenuCommonFilterLibContext.tenant_zipcode) {
            allZipcodes = allZipcodes.concat(sideMenuCommonFilterLibContext.tenant_zipcode);
        }
        
        allZipcodes.map(zipcodeObj => {
            let zone = `${zipcodeObj.country_code} - ${zipcodeObj.zone}`; 
            if (!zones.includes(zone)) {
                zones.push(zone);
            }
        });
        setAllZones(zones.sort());
    };

    const styles: StylesConfig<ColourOption, true> = {
        control: (base, state) => ({
            ...base,
            "border-top": "0",
            "border-left": "0",
            "border-right": "0",
            "border-radius": "0",
            boxShadow: state.isFocused ? 0 : 0,
        }),
        option: (base, {isFocused, isSelected, isMulti}) => ({
            ...base,
            color: isFocused
                ? '#000'
                : isSelected
                    ? '#000'
                    : undefined,
            background: isFocused
                ? 'rgba(0, 0, 0, 0.08)'
                : isSelected
                    ? 'rgba(0, 0, 0, 0.07)'
                    : undefined,
            ":hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)",
            },
            ":before": {
                content: isMulti 
                    ?  isSelected
                        ? '"☑ "' 
                        : '"☐ "' 
                    : '""'
            }
        }),
        singleValue: (base, state) => ({
            ...base,
            "color": "#316CF4"
        }),
        multiValue: (base, state) => ({
            ...base,
            "color": "#316CF4",
            "background-color": "#fff",
            "border": "1px solid #c0c0c0",
            "border-radius": "12px",
        }),
        menuPortal: provided => ({ ...provided, zIndex: 9999 }),
        //menu: provided => ({ ...provided, zIndex: 9999 }),
        multiValueRemove: (base, state) => ({
            ...base,
            "opacity": (state.data.value == "ALL") ? "0" : "1",
            "width": (state.data.value == "ALL") ? "0" : "auto",
            ":hover": {
                backgroundColor: "rgba(0, 0, 0, 0.05)",
                "border-top-right-radius": "12px",
                "border-bottom-right-radius": "12px",
            },
        }),
        multiValueLabel: (styles: any) => ({
            ...styles,
            whiteSpace: "normal",
            "color": "#316CF4",
        }),
    };

    const setFinalValues = () => {
        setFilters();
    }

    const setFilters = () => {
        let newSet = { ...filterBtnsSelected};
        let newSideMenuCommonFilterContext  = {...sideMenuCommonFilterContext};
        newSet['singleZone'] = selectedZone;
        newSideMenuCommonFilterContext['singleZone'] = selectedZone;
        
        setFilterBtnsSelected(newSet);
        setSideMenuCommonFilterContext(newSideMenuCommonFilterContext);
    };

    const renderZoneSelect = () => {
        return (<Select
            isMulti={false}
            onFocus={e => setIsZoneMenuOpen(true)}
            onBlur={e => {
                setIsZoneMenuOpen(false);
                setFinalValues();
            }}
            components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}
            hideSelectedOptions={false}
            styles={styles}
            value={populateValues(selectedZonValues())}
            isClearable={selectedZone.length != 0}
            onChange={item => {
                let zones = [];
                if (item) {
                    zones = zones.concat(item.value);
                }
                setSelectedZone(zones);
                setIsZoneMenuOpen(false);
            }}
            options={allZones.map(zipcodeObj => {
                return {
                    label: zipcodeObj,
                    value: zipcodeObj,
                }
            })}
            placeholder="Select A Zone"
            menuPortalTarget={document.body}
        />);
    }

    const selectedZonValues = () => {
        let zonValues = [];
        selectedZone.map(zoneSingle => {
            zonValues.push({
                label: zoneSingle,
                value: zoneSingle
            });
        }); 
        return zonValues;
    };

    const populateValues = (defaultValue) => {
        if (defaultValue.length) {
            return defaultValue;
        } else {
            return [{
                label: "ALL",
                value: "ALL",
                isFixed: true
            }]
        }
    };

    return (<>
        <div
            key={`${ele.name}_zone`}
            title={"Zone"}
            className={
            `filter-name ${ele.advance ? "filter-advanced" : ""} ${ele?.size ? ele?.size : ""} ${ele.name}-zone-label-filter-name` +
            (selected ? "selected" : "") +
            (ele.disabled ? " disabled" : "")
            }
        >
            {<div className="name-top">{"Zone"}</div>}
            {renderZoneSelect()}
        </div>
    </>);

};

export default FilterZoneWidget;